import { useCallback } from 'react'

import { useApp } from '../../../app/AppContext.jsx'

import { HERO_VIEW } from '../../../shared/constants/heroView.js'
import { SECTION_ID } from '../../../shared/constants/sectionIds.js'

import { useHero } from '../context/HeroContext.jsx'

export function resolveHeroProductNavigation(products, uuid) {
  const product = (products ?? []).find((entry) => entry.uuid === uuid)

  return {
    buildingId: product?.building_id ?? null,
    refTier: product?.ref_tier ?? null,
  }
}

export function useHeroSectionNavigation({ products = [], onAfterNavigate } = {}) {
  const {
    setActiveBuilding,
    setActiveTier,
    activateSectionHandler,
    selectProductHandler,
    isMobile,
  } = useApp()

  const { changeViewHandler } = useHero()

  const runAfterNavigate = useCallback(() => {
    onAfterNavigate?.()
  }, [onAfterNavigate])

  const goToBuildingModel = useCallback((buildingId) => {
    if (buildingId == null || buildingId === '') return

    setActiveBuilding(buildingId)
    changeViewHandler(HERO_VIEW.BUILDING, { buildingId })
    runAfterNavigate()
  }, [changeViewHandler, runAfterNavigate, setActiveBuilding])

  const goToTierSection = useCallback((refTier, buildingId = null) => {
    if (refTier == null) return

    setActiveTier(refTier)
    setActiveBuilding(buildingId ?? null)
    activateSectionHandler(SECTION_ID.TIERS, {
      scrollTarget: isMobile ? null : SECTION_ID.TIERS,
    })
    runAfterNavigate()
  }, [activateSectionHandler, isMobile, runAfterNavigate, setActiveBuilding, setActiveTier])

  const goToProductSection = useCallback((uuid) => {
    if (uuid == null || uuid === '') return

    selectProductHandler(uuid, {
      ...resolveHeroProductNavigation(products, uuid),
      scrollTarget: isMobile ? null : SECTION_ID.PRODUCT,
    })
    runAfterNavigate()
  }, [isMobile, products, runAfterNavigate, selectProductHandler])

  return {
    goToBuildingModel,
    goToTierSection,
    goToProductSection,
  }
}